import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css'

import { FaWhatsapp } from "react-icons/fa";
import { FaAnglesUp } from "react-icons/fa6";


import ScrollToTop from './Webpages/ScrollToTop'

import WebHeader from './Components/WebHeader'
import WebFooter from './Components/WebFooter'
import HomePage from './Webpages/HomePage'
import Contact from './Webpages/Contact';
import OurProducts from './Webpages/OurProducts';
import logoarrow from '../src/Assets/Image/trident-logo.jpg'
import Enterprise from '../src/Webpages/Enterprise'
import Diversity from './Webpages/Diversity';
import StartupsPage from './Webpages/Startups';
import Consultanats from './Webpages//Consultants';
import Ecommerce from './Webpages/Ecommerce';



// Pages
const App = () => {

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <BrowserRouter>

      <WebHeader />
      <div>
        <ScrollToTop />
        <Routes>

          <Route path="*" name="HomePage" element={<HomePage />} />
          <Route path="/" name="HomePage" element={<HomePage />} />
          <Route path="/ourproducts" name="OurProducts" element={<OurProducts />} />
          <Route path="/contact" name="Contact" element={<Contact />} />
          <Route path="/enterprise" name="Contact" element={<Enterprise />} />
          <Route path="/diversity" name="Contact" element={<Diversity />} />
           <Route path="/ecommerce" name="Contact" element={<Ecommerce />} />
          <Route path="/startups" name="Contact" element={<StartupsPage />} />
          <Route path="/consultants" name="Contact" element={<Consultanats />} />


        </Routes>

        {/* <a
          href="https://wa.me/13122847077"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with us!"
        >
          <FaWhatsapp />
        </a> */}


        {showScroll && (
          <button className="scroll-to-top show" onClick={scrollToTop}>
            <img src={logoarrow} alt="Scroll to top" title='Scroll to Top'
              style={{ width: '40px', height: '40px' }} />
          </button>
        )}
      </div>
      <WebFooter />
    </BrowserRouter>
  )
}

export default App
